
import React from 'react';
import Dashboard from './Dashboard';
import { UpdateNotification } from '@/components/common/UpdateNotification';

const Index = () => {
  return (
    <>
      <Dashboard />
      <UpdateNotification />
      {/* Toaster removed from here - consolidated in App.tsx */}
    </>
  );
};

export default Index;
